import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { OrganigrammeComponent } from './organigramme.component';
import { AddNodeMenuComponent } from './add-node-menu.component';
import { OrganigrammeService } from './organigramme.service';
import { OrganigrammeEntityResolver } from './entity.resolver';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    OrganigrammeComponent,
    AddNodeMenuComponent
  ],
  providers: [
    OrganigrammeService,
    OrganigrammeEntityResolver
  ],
})
export class OrganigrammeModule { }
